<template>
  <!-- _________________________ LOGIN _________________________ -->
  <div id="login-div" class="position-absolute">

    <h1 class="page-uptitle mt-5">
      {{ $t('loginTitle') }}
    </h1>
    <h1 class="page-title">
      {{ $t('loginTitle2') }}
    </h1>
    <h2 class="page-subtitle mt-5">
      {{ $t('loginSubtitle') }}
    </h2>

    <form @submit.stop.prevent="handleSubmit" class="mt-4">

      <b-alert :show="ui.showError" variant="danger">
        {{ ui.showErrorMessage }}
        <a href="#" v-on:click="resendValidateAccountMail" v-if="ui.showValidateAccountError">
          {{$t('account.not.validated.resent.error')}}
        </a>
      </b-alert>

      <b-alert :show="ui.showResendValidateAccountMailSuccess" variant="success">
        {{ $t('ResendValidateAccountMail.success') }}
      </b-alert>

      <b-alert :show="showAccountCreationSuccess" variant="success">
        {{ ui.AccountCreationSuccessMessage }}
      </b-alert>

      <b-form-group
        :label="$t('loginFirstCredential')"
        label-for="username-input"
        class="bold-label mb-4">
        <b-form-input
          id="username-input"
          v-model="form.username.value"
          type="email"
          required
          @keydown="hideError">
        </b-form-input>
      </b-form-group>

      <password-field
        :password="form.password"/>

      <div class="row justify-content-between">
        <div class="col" >
          <b-form-checkbox
            class="mt-4 remember-me"
            id="remember_me"
            v-model="form.rememberMe.value">
            {{ $t('Remember.me') }}
          </b-form-checkbox>
        </div>
        <div class=" col mt-4 text-right">
          <b-link v-on:click="showForgotPasswordView" class="forgot-password-link">{{ $t('forgotPasswordText') }}</b-link>
        </div>
      </div>

      <div class="mt-4">
        <b-button type="submit" class="btn-block" variant="primary">
          <span v-if="!isLoading">{{ $t('LogInButtonText') }}</span>
          <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
        </b-button>
      </div>

    </form>

    <div class="mt-4 text-center">
      {{ $t('NoAccountYet')}}  <b-link id="register-link" v-on:click="showRegisterView" class="">{{ $t('CreateAccount') }}</b-link>
    </div>

  </div>
</template>

<script>

import {mapActions} from 'vuex'
import api from '../../../services/api'
import PasswordCreationField from "../../../components/b122/editFields/PasswordCreationField.vue";
import PasswordField from "../../../components/b122/editFields/PasswordField.vue";

export default {

  name: 'LoginComponent',
  components: {PasswordField, PasswordCreationField},

  props: {
    showAccountCreationSuccess: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isLoading: false,
      form: {
        username: {
          value: null
        },
        password: {
          value: null
        },
        rememberMe: {
          value: false
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error'),
        showValidateAccountError: false,
        showResendValidateAccountMailSuccess: false,
        AccountCreationSuccessMessage: this.$i18n.t('Register.success')
      }
    }
  },

  emits: ['showForgotPasswordView', 'showSmsCodeView', 'showRegisterView'],

  mounted () {
  },

  methods: {

    ...mapActions(['LogIn', 'setRememberMe']),

    async handleSubmit () {

      this.isLoading = true

      let data = {
        username: this.form.username.value.trim(),
        password: this.form.password.value.trim()
      }

      this.setRememberMe(this.form.rememberMe.value)
      if (this.form.rememberMe.value) {
        data['remember-me'] = true
      }

      let formData = new FormData()
      formData.append('username', data['username'])
      formData.append('password', data['password'])

      await api({
        method: 'POST',
        url: '/authentication/beforeLogin',
        data: formData
      })
        .then(async (response) => {
          let displaySmsCodeValidation = response.data.displayCodeValidation
          if (displaySmsCodeValidation) {
            // code sms
            let phoneNumber = Object(response.data)['phoneNumber']
            this.showSmsCodeView(data['username'], data['password'], phoneNumber)
          } else {
            // login
            await this.LogIn(data)
              .then(async () => {
                this.ui.showError = false
                this.goToHome()
              })
              .catch((error) => {
                if (error.toString() === 'Locked') {
                  this.ui.showErrorMessage = this.$i18n.t('Account.forbidden.error')
                  this.ui.showError = true
                }
              })
          }
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }
          if (error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    resendValidateAccountMail () {
      this.hideError()

      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMail`,
        data: formData
      })
        .then(() => {
          this.ui.showResendValidateAccountMailSuccess = true
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    showRegisterView () {
      this.$emit('showRegisterView')
    },

    showForgotPasswordView () {
      this.$emit('showForgotPasswordView')
    },

    showSmsCodeView (username, password, phoneNumber) {
      this.$emit('showSmsCodeView', username, password, phoneNumber)
    },

    hideError () {
      this.ui.showError = false
      this.ui.showErrorMessage = null
      this.ui.showValidateAccountError = false
    },

    hideMessages () {
      this.ui.showResendValidateAccountMailSuccess = false
      this.hideError()
    },

    goToHome () {
      this.$router.push({
        name: '/'
      })
    }

  }

}

</script>

<style scoped>

.forgot-password-link {
  text-decoration: none;
}

#register-link {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/auth/components/LoginComponent.vue